<template>
	<section
		class="view-venue-submissionform"
		v-bind:class="{
			'state-loading': loading,
		}"
	>
		<section class="padded text-center" v-if="complete">
			<figure class="push-bottom">
				<img class="icon filter-invert" src="~@chalkysticks/sass/build/asset/image/icon/checkmark.svg" />
			</figure>

			<h3>Thank you!</h3>

			<p class="padded">
				We appreciate you supporting ChalkySticks and helping us grow the sport of pool. We will review this
				shortly.
			</p>
		</section>

		<form class="location-search" v-on:submit="Handle_OnSubmitSearch" v-else-if="!googlePlaceModel.uniqueKey">
			<fieldset>
				<label>
					<h6>Search for location</h6>
					<input
						autocomplete="name"
						minlength="6"
						name="name"
						ref="nameInput"
						required
						type="text"
						v-bind:placeholder="placeholder"
						v-model="venueModel.attributes.name"
						v-on:keyup.enter="Handle_OnSubmitSearch"
					/>
				</label>

				<div class="actions button-group">
					<img
						class="animate-spin filter-invert"
						height="24"
						src="~@chalkysticks/sass/build/asset/image/icon/loading.svg"
						v-bind:key="googlePlaceModel.uniqueKey"
						v-if="googlePlaceModel.loading"
						width="24"
					/>
					<button class="button-primary" v-else>Search</button>
				</div>

				<footer>
					<small class="type-small-paragraph">
						For best results, enter the name of the
						<br />
						venue and the city it is located in.
					</small>
				</footer>
			</fieldset>
		</form>

		<section v-bind:key="googlePlaceModel.uniqueKey" v-else>
			<figure v-if="googlePlaceModel.photos">
				<img class="rounded" v-bind:src="googlePlaceModel.photos[0].url" />

				<figcaption class="pad-top pad-bottom">
					<h3 class="name type-large-paragraph">{{ googlePlaceModel.getName() }}</h3>
					<p class="address color-chalky-grey-2 type-small-paragraph">{{ googlePlaceModel.getAddress() }}</p>
				</figcaption>
			</figure>

			<div class="actions button-group" v-if="!showDetails">
				<button class="button-secondary" v-on:click="Handle_OnClickCancel">Cancel</button>
				<button class="button-primary" v-on:click="Handle_OnClickAccept">Continue</button>
			</div>
		</section>

		<section class="details" v-if="showDetails && !complete">
			<fieldset>
				<h5>Venue Details</h5>
				<label>
					<input class="switch" type="checkbox" v-model="venueModel.hasFood" />
					<span>Do they serve food?</span>
				</label>
				<label>
					<input class="switch" name="cashOnly" type="checkbox" v-model="venueModel.cashOnly" />
					<span>Is it cash only?</span>
				</label>
				<label>
					<input class="switch" name="gambling" type="checkbox" v-model="venueModel.gambling" />
					<span>Does anyone gamble here?</span>
				</label>
				<label>
					<input class="switch" name="freeTable" type="checkbox" v-model="venueModel.freeTable" />
					<span>Are any of the tables free?</span>
				</label>
				<label>
					<input class="switch" name="livemusic" type="checkbox" v-model="venueModel.livemusic" />
					<span>Live music</span>
				</label>
				<label>
					<input class="switch" name="smoking" type="checkbox" v-model="venueModel.smoking" />
					<span>Smoking allowed indoors</span>
				</label>
			</fieldset>

			<fieldset>
				<h5 class="push-top">Events</h5>
				<label>
					<input class="switch" name="hasLeague" type="checkbox" v-model="venueModel.hasLeague" />
					<span>Do they have pool leagues here?</span>
				</label>
				<label>
					<input class="switch" name="tournaments" type="checkbox" v-model="venueModel.tournaments" />
					<span>Do they host tournaments?</span>
				</label>
			</fieldset>

			<fieldset>
				<h5 class="push-top">Equipment</h5>
				<label>
					<input class="switch" name="table7" type="checkbox" v-model="venueModel.table7" />
					<span>Do they have a 7' Table?</span>
				</label>
				<label>
					<input class="switch" name="table8" type="checkbox" v-model="venueModel.table8" />
					<span>Do they have a 8' Table?</span>
				</label>
				<label>
					<input class="switch" name="table9" type="checkbox" v-model="venueModel.table9" />
					<span>Do they have a 9' Table?</span>
				</label>
				<label>
					<input class="switch" name="snooker" type="checkbox" v-model="venueModel.snooker" />
					<span>Do they have a snooker table?</span>
				</label>
				<label>
					<input class="switch" name="billiards" type="checkbox" v-model="venueModel.billiards" />
					<span>Do they have a billiards table?</span>
				</label>
				<label>
					<input class="switch" name="pingPong" type="checkbox" v-model="venueModel.pingPong" />
					<span>Do they have a ping pong table?</span>
				</label>
				<label>
					<input class="switch" name="darts" type="checkbox" v-model="venueModel.darts" />
					<span>Do they have a dart board?</span>
				</label>
				<label>
					<input class="switch" name="foosball" type="checkbox" v-model="venueModel.foosball" />
					<span>Do they have a foosball table?</span>
				</label>
			</fieldset>

			<fieldset>
				<label style="margin-top: 0">
					<h6>Additional Notes</h6>

					<textarea
						name="notes"
						placeholder="Anything else you think we should know?"
						v-model="venueRevisionModel.attributes.notes"
					></textarea>
				</label>

				<label>
					<h6 class="push-top">Photo</h6>

					<input type="file" accept="image/*" name="image" v-on:change="Handle_OnChangeImage" />

					<p class="type-small-paragraph padded small">
						Upload a photo of the table, interior, or exterior if you have one.
					</p>
				</label>
			</fieldset>

			<div class="actions button-group">
				<button class="cancel button-secondary" v-on:click="Handle_OnClickCancel">Cancel</button>
				<button class="submit button-primary" type="submit" v-on:click="Handle_OnSubmitVenue">Submit</button>
			</div>

			<p class="type-small-paragraph push-top text-center">
				We will review your submission before it is published.
			</p>
		</section>
	</section>
</template>

<script lang="ts">
	import * as Service from '@/App/Service';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueSubmissionForm extends ViewBase {
		/**
		 * @type ChalkySticks.Model.GooglePlace
		 */
		protected googlePlaceModel: ChalkySticks.Model.GooglePlace = ChalkySticks.Factory.GooglePlace.model();

		/**
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		/**
		 * @type ChalkySticks.Model.VenueRevision
		 */
		@Prop({
			default: () => ChalkySticks.Factory.VenueRevision.model(),
		})
		public venueRevisionModel!: ChalkySticks.Model.VenueRevision;

		/**
		 * @type string
		 */
		private placeholder: string = 'Tap a Keg, NY';

		/**
		 * @type string[]
		 */
		private placeholders: string[] = [
			'Tap a Keg, NY',
			'Cousins, OK',
			'Amsterdam Billiards',
			'Clicks, Orlando',
			'Eagle Billiards, PA',
		];

		/**
		 * @type boolean
		 */
		private complete: boolean = false;

		/**
		 * @type boolean
		 */
		private showDetails: boolean = false;

		/**
		 * @type File | null
		 */
		private imageFile: File | null = null;

		/**
		 * @type boolean
		 */
		private loading: boolean = false;

		/**
		 * @type Service.VenueRevision
		 */
		private venueRevisionService: Service.VenueRevision;

		/**
		 * @constructor
		 */
		constructor() {
			super();

			this.venueRevisionService = new Service.VenueRevision(this);
		}

		/**
		 * @return void
		 */
		@mounted
		public attachEvents(): void {
			ChalkySticks.Utility.Interval.add(this.Handle_OnChangePlaceholder, 1000 * 5, 'submission-placeholder');
		}

		/**
		 * @return void
		 */
		@beforeDestroy
		public detachEvents(): void {
			ChalkySticks.Utility.Interval.remove('submission-placeholder');
		}

		/**
		 * Resets the view to its initial state.
		 * Clears the Google Place model, sets complete to false, and hides the details section.
		 *
		 * @return void
		 */
		protected reset(): void {
			this.complete = false;
			this.googlePlaceModel.reset();
			this.showDetails = false;
			this.venueModel.reset();
		}

		/**
		 * Handles venue submission errors with appropriate user messaging
		 *
		 * @param number status
		 * @param string serverMessage
		 * @return void
		 */
		protected handleSubmissionError(status: number, serverMessage?: string): void {
			if (status === 401) {
				this.$alert.alert('You must be logged in to submit a venue.');
			} else if (serverMessage) {
				this.$alert.alert(serverMessage);
			} else {
				// Handle specific error cases
				const messages: Record<number, string> = {
					400: 'Please fill in all required fields.',
					403: 'You are not allowed to submit a venue revision.',
					409: 'A revision matching these details already exists. Great minds think alike!',
					422: 'A revision matching these details already exists. Great minds think alike!',
				};
				const message = messages[status] || 'An error occurred while submitting the venue.';
				this.$alert.alert(message);
			}
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param Event e
		 * @return Promise<void>
		 */
		protected async Handle_OnChangePlaceholder(e: Event): Promise<void> {
			const index = ChalkySticks.Utility.Math.randomInt(0, this.placeholders.length);
			this.placeholder = this.placeholders[index];
		}

		/**
		 * Handles the click event for accepting the selected location.
		 * Smoothly scrolls the page to 200px on the Y axis and shows the details section.
		 *
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickAccept(e: PointerEvent): Promise<void> {
			e.preventDefault();

			const pageNode = document.querySelector('[class*="page-"]');

			// Show details
			this.showDetails = true;

			// Smooth scroll to 200px Y axis
			setTimeout(
				() =>
					pageNode?.scrollTo({
						behavior: 'smooth',
						top: 200,
					}),
				100,
			);
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickCancel(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.reset();
		}

		/**
		 * @param Event e
		 * @return Promise<void>
		 */
		protected async Handle_OnSubmitSearch(e: Event): Promise<void> {
			e.preventDefault();

			// Search geocode model
			this.googlePlaceModel.setQueryParam('address', this.venueModel.attributes.name);

			// Fetch data
			await this.googlePlaceModel.fetch();

			// Update the Venue
			this.venueModel.set(this.googlePlaceModel.place);
		}

		/**
		 * Handles the change event for the image file input.
		 * Stores the selected file in the imageFile property.
		 *
		 * @param Event e
		 * @return void
		 */
		protected Handle_OnChangeImage(e: Event): void {
			const target = e.target as HTMLInputElement;

			if (target && target.files && target.files.length > 0) {
				this.imageFile = target.files[0];
			} else {
				this.imageFile = null;
			}
		}

		/**
		 * Handles the venue submission, including image upload
		 *
		 * @param Event e
		 * @return Promise<void>
		 */
		protected async Handle_OnSubmitVenue(e: Event): Promise<void> {
			e.preventDefault();

			this.loading = true;
			this.venueRevisionService = new Service.VenueRevision(this);

			const success = await this.venueRevisionService.submit(
				{
					additionalData: this.venueModel.toJSON(),
					imageFile: this.imageFile,
					notes: this.venueRevisionModel.attributes.notes,
				},
				{
					endpoint: this.venueRevisionModel.b.getUrl(),
					onError: (status: number, serverMessage?: string) => {
						this.handleSubmissionError(status, serverMessage);
					},
					onSuccess: () => {
						this.complete = true;
					},
				},
			);

			this.loading = false;
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-submissionform {
		.location-search {
			header {
				margin-top: 3rem;
			}

			footer {
				margin: 0 auto;
				margin-top: 1rem;
				text-align: center;
			}
		}
	}

	// State
	// ---------------------------------------------------------------------------

	.view-venue-submissionform.state-loading {
		opacity: 0.75;
		pointer-events: none;

		button.submit {
			background-image: url("data:image/svg+xml,%0A%3Csvg version='1.1' id='L9' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 100 100' enable-background='new 0 0 0 0' xml:space='preserve'%3E%3Cpath fill='%23fff' d='M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50'%3E%3CanimateTransform attributeName='transform' attributeType='XML' type='rotate' dur='1s' from='0 50 50' to='360 50 50' repeatCount='indefinite' /%3E%3C/path%3E%3C/svg%3E");
			background-repeat: no-repeat;
			background-size: 30px;
			background-position: 0.5rem center;

			.icon {
				opacity: 0;
			}
		}
	}
</style>
